"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Add = _interopRequireDefault(require("@material-ui/icons/Add"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _IconButton = _interopRequireDefault(require("../IconButton"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    container: {
      alignItems: 'center',
      backgroundColor: theme.palette.grey[100],
      border: "1px solid ".concat(theme.palette.grey[400]),
      display: 'flex',
      height: '36px',
      paddingLeft: theme.spacing(0.75),
      // 6px + 8px from IconButton + 4px from Icon = 18px
      paddingRight: theme.spacing(1)
    },
    typography: {
      marginLeft: theme.spacing(0.5)
    }
  };
});
var defaultIconButtonProps = {
  'aria-label': 'Expand',
  color: 'secondary'
};
var defaultProps = {
  dataMetrics: {
    root: 'fuse_collapsed_condition_group'
  },
  icon: /*#__PURE__*/_react["default"].createElement(_Add["default"], null)
};

/**
 * CollapsedConditionGroup is a subcomponent of the ConditionGroup component.
 * As such, it probably shouldn't be used on its own.
 * Its primary purpose is to display a collapsed version of the
 * ExpandedConditionGroup component, allowing users to quickly read information
 * about a collection of conditions.
 */
var CollapsedConditionGroup = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var children = props.children,
    className = props.className,
    dataMetrics = props.dataMetrics,
    icon = props.icon,
    IconButtonProps = props.IconButtonProps,
    onIconButtonClick = props.onIconButtonClick,
    TypographyProps = props.TypographyProps;
  var styles = useStyles();
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  var mergedIconButtonProps = _objectSpread({}, defaultIconButtonProps, {}, IconButtonProps);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(styles.container, className),
    "data-metrics": mergedDataMetrics.root,
    ref: ref
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], (0, _extends2["default"])({}, mergedIconButtonProps, {
    onClick: onIconButtonClick
  }), icon), /*#__PURE__*/_react["default"].createElement(_Typography["default"], (0, _extends2["default"])({
    variant: "body1"
  }, TypographyProps, {
    className: (0, _classnames["default"])(styles.typography, TypographyProps === null || TypographyProps === void 0 ? void 0 : TypographyProps.className)
  }), children));
});
CollapsedConditionGroup.displayName = 'CollapsedConditionGroup';
CollapsedConditionGroup.defaultProps = defaultProps;
CollapsedConditionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The content of the component.
   */
  children: _propTypes["default"].node.isRequired,
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string
  }),
  /**
   * The icon element.
   */
  icon: _propTypes["default"].element,
  /**
   * The props to pass to the ```IconButton``` component.
   */
  IconButtonProps: _propTypes["default"].object,
  /**
   * Callback fired when the IconButton is clicked.
   */
  onIconButtonClick: _propTypes["default"].func,
  /**
   * The props to pass to the Typography component.
   */
  TypographyProps: _propTypes["default"].object
} : {};
var _default = CollapsedConditionGroup;
exports["default"] = _default;